import { Handle, Position } from "@xyflow/react";

export function GhostNode() {
  return (
    <div style={{ width: 0, height: 0, display: "none" }}>
      <Handle type="target" position={Position.Top} isConnectable={false} style={{ background: "white" }} />
    </div>
  );
}
